import {
  FailableAction,
  failableActionCreator,
  Memoed,
  PayloadAction,
  payloadActionCreator,
  Loadable,
  actionCreator,
  Action,
} from '@library/react-toolkit'
import { LocationChangeAction } from 'connected-react-router'
import { eq, option } from 'fp-ts'
import { Customer } from '../../types'

export const eqCustomer: eq.Eq<Customer> = {
  equals: (a, b) =>
    a.id === b.id ||
    a.email === b.email ||
    a.phoneNumber === b.phoneNumber ||
    a.taxNumber === b.taxNumber,
}

export type NewCustomer = Omit<Customer, 'id'>

export type Query = {
  page: number
  itemsPerPage: number
  sort?: [keyof Customer, 'asc' | 'desc']
}

export type CustomersData = { data: Customer[]; count: number }

export type State = {
  payers: Memoed<CustomersData>
  query: Query
  addResult: Loadable<unknown>
  createModalOpen: boolean
  deleteResult: Loadable<unknown>
  selectedPayer: option.Option<number>
  editingPayer: option.Option<Customer>
  editResult: Loadable<unknown>
}

export type GetPayersAction = PayloadAction<'PAYERS/get', Partial<Query>>
export const getPayersAction =
  payloadActionCreator<GetPayersAction>('PAYERS/get')

export type GetPayersResult = FailableAction<'PAYERS/get_result', CustomersData>
export const getPayersResult =
  failableActionCreator<GetPayersResult>('PAYERS/get_result')

export type AddPayerAction = PayloadAction<'PAYERS/add', NewCustomer>
export const addPayerAction = payloadActionCreator<AddPayerAction>('PAYERS/add')

export type AddPayerResult = FailableAction<'PAYERS/add_result', unknown>
export const addPayerResult =
  failableActionCreator<AddPayerResult>('PAYERS/add_result')

export type ToggleCreatePayerModal = Action<'PAYERS/toggle_create_modal'>
export const toggleCreatePayerModal = actionCreator<ToggleCreatePayerModal>(
  'PAYERS/toggle_create_modal'
)

export type DeletePayerAction = PayloadAction<'PAYERS/delete', Customer>
export const deletePayerAction =
  payloadActionCreator<DeletePayerAction>('PAYERS/delete')

export type DeletePayerResult = FailableAction<'PAYERS/delete_result', unknown>
export const deletePayerResult = failableActionCreator<DeletePayerResult>(
  'PAYERS/delete_result'
)

export type ViewPayerAction = PayloadAction<'PAYERS/view', number>
export const viewPayerAction =
  payloadActionCreator<ViewPayerAction>('PAYERS/view')

export type CloseViewPayerAction = Action<'PAYERS/close_view'>
export const closeViewPayerAction =
  actionCreator<CloseViewPayerAction>('PAYERS/close_view')

export type StartEditAction = PayloadAction<'PAYERS/start_edit', Customer>
export const startEditAction =
  payloadActionCreator<StartEditAction>('PAYERS/start_edit')

export type CancelEditAction = Action<'PAYERS/cancel_edit'>
export const cancelEditAction =
  actionCreator<CancelEditAction>('PAYERS/cancel_edit')

export type EditPayerAction = PayloadAction<'PAYERS/edit', NewCustomer>
export const editPayerAction =
  payloadActionCreator<EditPayerAction>('PAYERS/edit')

export type EditPayerResult = FailableAction<'PAYERS/edit_result', unknown>
export const editPayerResult =
  failableActionCreator<EditPayerResult>('PAYERS/edit_result')

export type Actions =
  | GetPayersAction
  | GetPayersResult
  | AddPayerAction
  | AddPayerResult
  | DeletePayerAction
  | DeletePayerResult
  | ToggleCreatePayerModal
  | ViewPayerAction
  | CloseViewPayerAction
  | StartEditAction
  | CancelEditAction
  | EditPayerAction
  | EditPayerResult
  | LocationChangeAction
